import { useEffect, useState } from "react";

import { Button, FormControl, FormErrorMessage, FormLabel, Input, Switch, Textarea, useDisclosure, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,Stack,VStack,SimpleGrid,Box,Text,Flex,Divider,Skeleton } from "@chakra-ui/react"
import { Field, FieldProps, Form, Formik } from "formik"
import { useLocation } from "react-router-dom"
import { HttpStatusCode } from "axios";
import { format } from "date-fns";
import DatePicker from 'react-datepicker';
import Select from "react-select";
import 'react-datepicker/dist/react-datepicker.css';
import ArrowIcon from "@/assets/ArrowIcon";
import AddOthersIcon from "@/assets/AddOthersIcon";
import RemoveOthersIcon from "@/assets/RemoveOthersIcon";
import ModalConfirmation from "@/components/Modals/ModalConfirmation";
import { COLORS, DURATION_TOAST, FORMAT_ADD_DATE, PPN_PERCENTAGE } from "@/common/constants";
import SelectCountry from "@/components/Selects/SelectCountry";
import CurrencyInput from "@/components/Fields/CurrencyInput";
import CurrencyExchangeDate from "@/components/Fields/CurrencyExchangeDate";
import Loader from "@/components/Layouts/Loader";
import SelectSireVettingType from "@/components/Selects/SelectSireVettingType";
import SelectTypeShipOperator from "@/components/Selects/SelectTypeShipOperator";
import SelectInspectionFee from "@/components/Selects/SelectInspectionFee";
import SelectInvoices from "@/components/Selects/SelectInvoices";
import EditFile from "@/components/Fields/EditFile";
import SelectCurrencyByRefData from "@/components/Selects/SelectCurrencyByRefData";
import { useAppSelector } from "@/redux/hooks";
import { RootState } from "@/redux/store";
import { getInvoicesShipOwnerById, InvoiceShipOperator, postInvoicesShipOwner, putInvoicesShipOwner } from "@/services/invoicesShipOwnerService";
import { invoiceShipOwnerSchema } from "@/schemas/invoiceShipOwnerSchema";

import { getShipOwnerData } from "@/services/shipOwnerService";
import { getSettingsById } from "@/services/settingService";
import { getInspectorFees } from "@/services/inspectionFeeService";
import { getInvoiceCompany } from "@/services/invoiceCompanyService";
import { getDataRef } from "@/services/refDataService";
import { getExchangeRate } from "@/services/exchangeRateService";
import { getCurrencySymbol, parseCurrencyFloat } from "@/utils/currency";
import { array10of0s, array1to10, setByIndex, otherArray, otherEvidenceFileIdArray, otherFeeArray } from "@/utils/arrayState";

import './customDatepicker.css';

type SetFieldValue<T> = (fieldName: string, newValue: T) => void;

const EditInvoicesShipOwner = () => {
    //const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isPreviewOpen, onOpen: onPreviewOpen, onClose: onPreviewClose } = useDisclosure();
    const toast = useToast();
    const location = useLocation();
    const role = useAppSelector((state: RootState) => state.account.roleName);
    const name = useAppSelector((state: RootState) => state.account.name);

    const { id } = location.state || {};

    const [awaitingDays, setAwaitingDays] = useState(0);
    const [awaitingDaysFee, setAwaitingDaysFee] = useState(0);
    const [confirmationText, setConfirmationTest] = useState("");
    const [confirmationTitleButton, setConfirmationTitleButton] = useState("");
    const [dataDetail, setDataDetail] = useState<InvoiceShipOperator | null>(null);
    const [dataEdit, setDataEdit] = useState<any>(null);
    const [defaultCompanyName, setDefaultCompanyName] = useState<any>(null);
    const [defaultShipName, setDefaultShipName] = useState<any>(null);
    const [inspectionFee, setInspectionFee] = useState(0);
    const [isDraft, setIsDraft] = useState(true);
    const [isPPN, setIsPPN] = useState(true);
    const [isSignature, setIsSignature] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [listCompanyName, setListCompanyName] = useState<any[]>([]);
    const [listRawCompanyName, setListRawCompanyName] = useState<any[]>([]);
    const [listShipName, setListShipName] = useState<any[]>([]);
    const [PPN, setPPN] = useState(0);
    const [PPNPercentage, setPPNPercentage] = useState(0);
    const [prefix, setPrefix] = useState('IDR');
    const [prefixDestination, setPrefixDestination] = useState('');
    const [status, setStatus] = useState(false);
    const [subTotal, setSubTotal] = useState(0);
    const [title, setTitle] = useState("");
    const [total, setTotal] = useState(0);
    const [totalArray, setTotalArray] = useState<number[]>(array10of0s());
    const [savedOthersFileIds, setSavedOthersFileIds] = useState<string[]>([]);
    const [visibleOthers, setVisibleOthers] = useState([1]);
    const [kurs, setKurs] = useState(0);
    const [kursDate, setKursDate] = useState<Date>(new Date(0));
    const [listInspectionFee, setListInspectionFee] = useState<any[]>([]);
    const [isPPNUpdated, setIsPPNUpdated] = useState(false);
    const [listRawInspectionFee, setListRawInspectionFee] = useState<any[]>([]);
    const [selectedFee, setSelectedFee] = useState<any>(null);
    const [listInvoiceCompany, setListInvoiceCompany] = useState<any[]>([]);
    const [listCurrency, setListCurrency] = useState<any[]>([]);
    //const [editableDocs, setEditableDocs] = useState<string[]>([]);
    const [statusKursConversion, setStatusKursConversion] = useState(false);
    const [currentConversionAmount, setCurrentConversionAmount] = useState(0);
    // const [currentConversionKurs, setCurrentConversionKurs] = useState(0);
    // const [convertionUploadFile, setConvertionUploadFile] = useState<File[]>() as any;
    const [isPreviewLoading, setIsPreviewLoading] = useState(false);
    const [previewData, setPreviewData] = useState<any>(null);

    const previewInvoice = (values: any) => {
        setIsPreviewLoading(true);
        try {
            const companyOption = listCompanyName.find((x: any) => x.value === values.companyName);
            const shipOption = listShipName.find((x: any) => x.value === values.shipName);
            const awaitingCost = (values.awaitingDays || 0) * (values.awaitingDaysFee || 0);
            const others: { label: string, amount: number }[] = [];
            array1to10.forEach((num, idx) => {
                const desc = values[otherArray[idx]];
                const feeVal = values[otherFeeArray[idx]] || 0;
                if (desc || feeVal) {
                    others.push({ label: desc || `Other ${num}`, amount: Number(feeVal) });
                }
            });
            const computedSubTotal = (values.inspectionFee || 0) + awaitingCost + others.reduce((sum, o) => sum + (o.amount || 0), 0);
            const computedPPN = values.isIndonesia && isPPN ? (PPNPercentage / 100) * computedSubTotal : 0;
            const computedTotal = prefix === 'IDR' ? computedSubTotal + computedPPN : computedSubTotal;
            setPreviewData({
                companyName: companyOption?.label || '',
                shipName: shipOption?.label || '',
                jobDescription: values.jobDescription || '',
                poNumber: values.poNumber || '',
                address: values.address || '',
                inspectionDate: values.inspectionDate ? format(values.inspectionDate, FORMAT_ADD_DATE) : '',
                invoiceDate: values.invoiceDate ? format(values.invoiceDate, FORMAT_ADD_DATE) : '',
                currencyPrefix: prefix,
                inspectionFee: values.inspectionFee || 0,
                awaitingDays: values.awaitingDays || 0,
                awaitingDaysFee: values.awaitingDaysFee || 0,
                awaitingCost,
                others,
                subTotal: computedSubTotal,
                ppn: computedPPN,
                total: computedTotal,
            });
        } finally {
            setIsPreviewLoading(false);
            onPreviewOpen();
        }
    }

    const handleCancel = () => {
        onOpen();
        setTitle("Cancel to Update Invoice?");
        setConfirmationTest("Are you sure you want to cancel?");
        setConfirmationTitleButton("Yes");
    }

    const handleSubmit = (data: any) => {
        if (data.invoiceDate < data.inspectionDate) {
            toast({
                title: 'Invalid date(s) entered',
                description: 'Invoice date cannot be earlier than inspection date.',
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
            return;
        }
        if (isDraft) {
            setTitle("Save Invoice?");
            setConfirmationTest("Are you sure you want to save invoice as draft?");
            setConfirmationTitleButton("Save Invoice");
        } else {
            setTitle("Update Invoice?");
            setConfirmationTest("Are you sure you want to update?");
            setConfirmationTitleButton("Update Invoice");
        }
        onOpen();
        setDataEdit(data);
        setIsSubmitting(true);
    }

    const generateDataEdit = () => {
        const companyData = listCompanyName.find((x: any) => x.value === dataEdit.companyName);
        const vesselData = listShipName.find((x: any) => x.value === dataEdit.shipName);

        const others: { desc: string, fee: string, file: File, fileId: string }[] = [];
        array1to10.map((num) => {
            const shouldExist = Boolean(dataEdit[`other${num}`] || dataEdit[`otherFee${num}`]);
            if (shouldExist) {
                others.push({
                    desc: dataEdit[`other${num}`] ?? '',
                    fee: dataEdit[`otherFee${num}`] ? parseCurrencyFloat(dataEdit[`otherFee${num}`]).toString() : '',
                    file: dataEdit[`otherCostFile${num}`] ?? '',
                    fileId: dataDetail?.[otherEvidenceFileIdArray[num - 1]] ?? '',
                })
            }
        });

        const data = new FormData();
        data.append('poNumber', dataEdit.poNumber || '');
        data.append('InvoiceId', dataEdit.invoiceID || '');
        data.append('SequenceID', dataDetail?.sequenceID || '');
        data.append('Type', dataEdit.type || '');
        data.append('SireType', dataEdit.sireType || '');
        data.append('InvoiceDate', dataEdit.invoiceDate ? format(dataEdit.invoiceDate, FORMAT_ADD_DATE) : '');
        data.append('CompanyName', companyData?.label || '');
        data.append('ShipOwnerId', dataEdit.companyName || '');
        data.append('InvoiceCompanyId', dataEdit.invoiceCompany || '');
        data.append('VesselId', dataEdit.shipName || '');
        data.append('ShipName', vesselData?.label || '');
        data.append('InspectionDate', dataEdit.inspectionDate ? format(dataEdit.inspectionDate, FORMAT_ADD_DATE) : '');
        data.append('Country', dataEdit.country || '');
        data.append('Port', dataEdit.port || '');
        data.append('IsIndonesia', dataEdit.isIndonesia ? 'true' : 'false');
        data.append('IsPPN', String(isPPN));
        data.append('IsSignature', dataEdit.isIndonesia ? (isSignature ? 'true' : 'false') : 'false');
        data.append('FeeId', dataEdit.fee || '');
        data.append('Kurs', kurs.toString() ?? '');
        data.append('KursDate', kursDate ? format(kursDate, FORMAT_ADD_DATE) : '');
        data.append('JobDescription', dataEdit.jobDescription || '');
        data.append('InspectionFee', inspectionFee ? inspectionFee.toString() : '');
        data.append('AwaitingDays', dataEdit.awaitingDays ? parseCurrencyFloat(dataEdit.awaitingDays).toString() : '');
        data.append('AwaitingDaysFee', awaitingDaysFee ? awaitingDaysFee.toString() : '');
        array1to10.map((num, index) => {
            const obj = others[index];
            if (obj) {
                data.append(`Other${num}`, obj.desc ?? '');
                data.append(`OtherFee${num}`, obj.fee ?? '');
                data.append(`OtherEvidence${num}File`, obj.file ?? '');
                data.append(`OtherEvidence${num}Id`, obj.fileId ?? '');
            } else {
                data.append(`Other${num}`, '');
                data.append(`OtherFee${num}`, '');
                data.append(`OtherEvidence${num}File`, '');
                data.append(`OtherEvidence${num}Id`, '');
            }
        });
        data.append('SubTotal', subTotal.toString() ?? '');
        data.append('PPN', dataEdit.isIndonesia ? PPNPercentage.toString() : '0');
        data.append('Amount', total.toString());
        data.append('PaymentStatus', '0');
        data.append('InvoiceStatus', isDraft ? '0' : '4');
        data.append('SKTDFile', dataEdit.SKTDFile ?? '');
        data.append('Address', dataEdit.address || '');
        data.append('IsKursConversion', dataEdit.isKursConversion ? 'true' : 'false');
        data.append('MataUang', dataEdit.targetExchangeRate || '');
        data.append('kursConversion', dataEdit.conversionKurs ? parseCurrencyFloat(dataEdit.conversionKurs).toString() : '');
        data.append('ConvertionNotes', dataEdit.conversionNotes || '');
        data.append('ConvertionUploadFile', dataEdit.conversionUploadFile ?? '');
        data.append('ConversionAmount', dataEdit.conversionAmount ? parseCurrencyFloat(dataEdit.conversionAmount).toString() : '');

        if (id) {
            data.append('Id', id);
            data.append('FakturFile', dataEdit.faktur ?? '');
            data.append('ModifiedBy', name || '');
        }
        // for (let [key, value] of data.entries()) {
        //     console.log(`${key}: ${value}`);
        // }
        return data;
    }

    const handleConfirm = async () => {
        onClose();

        if (title.startsWith("Cancel")) {
            history.back();
            //navigate('/manage-invoices/ship-operator');
            return;
        }

        const obj = generateDataEdit();
        let response
        if (id) {
            response = await putInvoicesShipOwner(obj);
        } else {
            response = await postInvoicesShipOwner(obj);
        }

        setIsSubmitting(false);
        if (response?.status === HttpStatusCode.Ok) {
            toast({
                title: 'Invoice updated.',
                description: "We've updated invoice.",
                status: 'success',
                duration: DURATION_TOAST,
                isClosable: true,
            });

            setTimeout(() => {
                history.back();
                //navigate('/manage-invoices/ship-operator')
            }, 1000)
        } else {
            toast({
                title: 'Inspector failed to update.',
                description: "We unabled to update invoice.",
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        }
    }

    const handleStatus = async (props: any) => {
        // 1. Determine the new state ONCE
        const isIndonesia = !status;

        // 2. Schedule all state updates using this new value
        props.setFieldValue('isIndonesia', isIndonesia);
        setStatus(isIndonesia);
        setPrefix(isIndonesia ? 'IDR' : 'USD'); // Corrected logic
        setIsPPN(isIndonesia);
        props.setFieldValue('kurs', '');
        if (isIndonesia) { // if selecting Indonesia
            const newFee = kurs * selectedFee?.price;
            props.setFieldValue('inspectionFee', newFee);
            setInspectionFee(newFee);

            const currentAwaitingFee = selectedFee?.fee * kurs;
            if (props.awaitingDays !== '') {
                handleChangeAwaitingDaysFee(currentAwaitingFee, props.setFieldValue);
            }

            const newTotals = totalArray.map((value) => value * kurs);
            newTotals.map((value, index) => props.setFieldValue(`otherFee${index + 1}`, (value === 0 ? '' : value)))
            setTotalArray(newTotals);

            const awaitingCost = (currentAwaitingFee ?? 0) * awaitingDays;

            let othersTotal = 0;
            array1to10.map((num) => {
                othersTotal += (props.values[`otherFee${num}`] || 0);
            });

            const total =
                (newFee ? Number(newFee) : 0) +
                (awaitingCost ? Number(awaitingCost) : 0) +
                (othersTotal * kurs);
            const addPPn = prefix === 'IDR' ? (isPPN ? ((PPNPercentage / 100) * total) : 0) + total : total;
            // setSubTotal(total);
            // setPPN(isPPN ? (PPNPercentage / 100) * total : 0);
            setTotal(addPPn);
            props.setFieldValue('isKursConversion', false);
        } else { // if deselecting Indonesia

            await getExchange();
            const price = status ? Math.round((dataDetail?.inspectionFee ?? 0) / kurs) : dataDetail?.inspectionFee;
            const newAwaitingDaysFee = status ? Math.round((dataDetail?.awaitingDaysFee ?? 0) / kurs) : dataDetail?.awaitingDaysFee;

            //handleChangeFee('', props);
            props.setFieldValue('fee', null);
            props.setFieldValue('inspectionFee', price || '');
            setInspectionFee(price ?? 0);
            setAwaitingDays(dataDetail?.awaitingDays ?? 0);
            props.setFieldValue('awaitingDays', dataDetail?.awaitingDays ?? '');
            setAwaitingDaysFee(newAwaitingDaysFee ?? 0);
            props.setFieldValue('awaitingDaysFee', newAwaitingDaysFee ?? '');

            const newTotals = otherFeeArray.map((otherFeeNum) => (dataDetail?.[otherFeeNum] || 0) as number);
            newTotals.map((value, index) => props.setFieldValue(`otherFee${index + 1}`, (value === 0 ? '' : value)));
            setTotalArray(newTotals);

            setCurrentConversionAmount(dataDetail?.conversionAmount || 0);
            setStatusKursConversion(Boolean(dataDetail?.isKursConversion));
        }
    }

    const handleAddOthers = (index: number) => {
        if (isSubmitting) {
            return;
        }

        const isExist = visibleOthers.includes(index + 1);
        if (!isExist) {
            setVisibleOthers([...visibleOthers, index + 1]);
        }
    }

    const handleRemoveOthers = (index: number, setFieldValue: (field: string, value: any) => void) => {
        if (isSubmitting) {
            return;
        }

        const isExist = visibleOthers.includes(index);
        if (isExist) {
            const newArr = visibleOthers.filter((x: number) => x !== index);
            setVisibleOthers(newArr);

            setFieldValue(`other${index}`, '');
            setFieldValue(`otherFee${index}`, '');
            setFieldValue(`OtherEvidence${index}File`, '');

            setTotalArray(setByIndex(totalArray, 0, index - 1))
        }
    }

    const handleConfirmToCancel = () => {
        setIsSubmitting(false);
        onClose();
    }

    const handleSelectCompany = (props: any, value: any) => {
        setListShipName([]);
        props.setFieldValue('companyName', value)
        props.setFieldValue('shipName', null)

        const myCompany = listRawCompanyName.find((x: any) => x.shipOwnerId === value);
        const formattedData = myCompany.vessels.map((item: any) => ({
            value: item.vesselId,
            label: item.vesselName,
        })) || [];

        setListShipName(formattedData);
        getListInvoice(value);
    }

    const handleSelectShipName = (props: any, value: any) => {
        const myShip = listShipName.find((x: any) => x.value === value);
        props.setFieldValue('shipName', myShip.value);
    }

    const handleChangeKurs = (value: number, props: any) => {
        props.setFieldValue('kurs', value);
        setKurs(value);

        const newFee = value * selectedFee?.price;
        props.setFieldValue('inspectionFee', newFee);
        setInspectionFee(newFee);
        const currentAwaitingFee = selectedFee?.fee * value;
        if (props.awaitingDays !== '') {
            handleChangeAwaitingDaysFee(currentAwaitingFee, props.setFieldValue);
        }
    }

    const handleChangeFee = (value: string, props: any) => {
        const selectedData = listRawInspectionFee.find((x: any) => x.id === value);
        setSelectedFee(selectedData);

        const price = status ? (selectedData?.price * kurs) : selectedData?.price;
        const awaitingDaysFee = status ? (selectedData?.fee * kurs) : selectedData?.fee;

        props.setFieldValue('inspectionFee', price);
        props.setFieldValue('fee', value);
        setInspectionFee(price);
        props.setFieldValue('awaitingDaysFee', '');
        setAwaitingDays(props.values.awaitingDays ? Number(props.values.awaitingDays) : 0);

        // let currentFee = 0;

        // if (props.values.isIndonesia && props.values.type === 'sire') {
        //     currentFee = props.values.awaitingDays * selectedData?.fee * kurs;
        // } else {
        //     currentFee = props.values.awaitingDays * selectedData?.fee;
        // }

        props.setFieldValue(`awaitingDaysFee`, awaitingDaysFee); //currentFee);
        setAwaitingDaysFee(awaitingDaysFee);
    }

    const handleChangeInspectionFee = (value: number, setFieldValue: any) => {
        if (value != null) {
            setFieldValue(`inspectionFee`, value);
            setInspectionFee(value);
        }
    }

    const handleChangeAwaitingDays = (value: number, setFieldValue: SetFieldValue<number>) => {
        // setAwaitingDays(value);
        // let currentFee = 0;

        // if (props.values.isIndonesia && props.values.type === 'sire') {
        //     currentFee = value * selectedFee?.fee * kurs;
        // } else {
        //     currentFee = value * selectedFee?.fee;
        // }

        // props.setFieldValue(`awaitingDays`, value);
        // props.setFieldValue(`awaitingDaysFee`, currentFee);
        // setAwaitingDaysFee(currentFee);

        setFieldValue(`awaitingDays`, value);
        // props.setFieldValue(`awaitingDaysFee`, currentFee);
        // setAwaitingDaysFee(currentFee);
        setAwaitingDays(value);
    }

    const handleChangeAwaitingDaysFee = (value: number, setFieldValue: SetFieldValue<number>) => {
        setFieldValue(`awaitingDaysFee`, value);
        setAwaitingDaysFee(value);
    }

    const handleChangeOtherCost = (index: number, value: number, setFieldValue: any) => {
        //setTotal(0);

        setTotalArray(setByIndex(totalArray, value, index - 1))
        setFieldValue(`otherFee${index}`, value);
    }

    const handleChangeType = (props: any, value: string) => {
        setPrefix(value === 'vetting' ? 'IDR' : 'USD');
        props.setFieldValue('type', value);
        getListInspectionFee(value);
        setIsPPN(false);
        props.setFieldValue(`inspectionFee`, 0);
        setInspectionFee(0);
    }

    const handleChangeInvoiceCompany = (props: any, e: any) => {
        if (e === null) {
            props.setFieldValue('invoiceCompany', '');
            return;
        }

        props.setFieldValue('invoiceCompany', e.value);
    }

    const handleChangeKursConversion = (props: any) => {
        props.setFieldValue('isKursConversion', !props.values.isKursConversion);
        setStatusKursConversion(!props.values.isKursConversion);
    }

    const handleChangeDestinationKurs = (props: any, value: string) => {
        props.setFieldValue('targetExchangeRate', value);

        const pref = getCurrencySymbol(value);
        if (pref) {
            setPrefixDestination(pref);
        }
    }

    const handleChangeKonversionKurs = (props: any, floatValue: any) => {
        props.setFieldValue('conversionKurs', floatValue);
        // setCurrentConversionKurs(floatValue);

        const totalConversion = floatValue * total;
        setCurrentConversionAmount(totalConversion);
    }

    const getListCompanyShipName = async () => {
        const response = await getShipOwnerData() as any;
        if (response.status === HttpStatusCode.Ok) {
            const formattedData = response.data.map((item: any) => ({
                value: item.shipOwnerId,
                label: item.onBehalfCompany,
                address: item.address,
            }));

            const rawData = response.data;
            return { formattedData, rawData };
        }

        return {};
    }

    const getListInvoice = async (id: string) => {
        const response = await getInvoiceCompany(id) as any;
        if (response.status === HttpStatusCode.Ok) {
            const formattedOptions = response.data.map((item: any) => ({ value: item.id, label: item.companyName }));
            setListInvoiceCompany(formattedOptions);
        } else {
            setListInvoiceCompany([]);
        }
    }

    const getListCurrency = async (value: string) => {
        const response = await getDataRef(value) as any;
        if (response.status === HttpStatusCode.Ok) {
            const formattedData = response.data.map((item: any) => ({
                label: item.name,
                value: item.value,
            }));

            setListCurrency(formattedData);
        }
    }

    const getDataDetail = async () => {
        const response = await getInvoicesShipOwnerById(id) as any;
        if (response) {
            setDataDetail(response.data);
            getListInspectionFee(response.data.type);
            getListInvoice(response.data?.shipOwnerId || '');
            setStatus(response.data.isIndonesia);
            if (response.data.type === 'vetting') {
                setPrefix('IDR');
            } else {
                if (response.data.isIndonesia) {
                    setPrefix('IDR');
                } else {
                    setPrefix('USD');
                }
            }

            setPrefixDestination(response.data.isKursConversion ? getCurrencySymbol(response.data.mataUang) : '');

            setIsPPN(response.data.isPPN);
            setIsSignature(response.data.isSignature);
            setPPN((response.data.isPPN ? PPNPercentage / 100 : 0) * response.data.subTotal);
            // setTotal(response.data.amount);
            // setSubTotal(response.data.subTotal);
            setInspectionFee(response.data.inspectionFee);
            setAwaitingDays(response.data.awaitingDays);
            setAwaitingDaysFee(response.data.awaitingDaysFee);
            // setKurs(response.data.kurs);
            setCurrentConversionAmount(response.data.conversionAmount);
            setStatusKursConversion(response.data.isKursConversion);

            if (response.data.mataUang) {
                const pref = getCurrencySymbol(response.data.mataUang);
                if (pref) {
                    setPrefixDestination(pref);
                }
            }

            const res: number[] = [];
            const totals: number[] = [];
            const othersFile: string[] = [];
            array1to10.map((num) => {
                totals.push(response.data[`otherFee${num}`] ?? 0)
                if (response.data[`other${num}`] || response.data[`otherCost${num}`] > 0) {
                    res.push(num);
                    othersFile.push(response.data[`otherEvidence${num}Id`]);
                }
            });
            if (res.length === 0) {
                res.push(1);
            }
            setTotalArray(totals);
            setVisibleOthers(res);
            setSavedOthersFileIds(othersFile);

            const { formattedData, rawData } = await getListCompanyShipName();
            setListCompanyName(formattedData);
            setListRawCompanyName(rawData);
            const myCompany = rawData.find((x: any) => x.shipOwnerId === response.data.shipOwnerId);
            setDefaultCompanyName({
                label: response.data.companyName, value: response.data.shipOwnerId
            });

            const formattedDataShip = myCompany?.vessels?.map((item: any) => ({
                value: item.vesselId,
                label: item.vesselName,
            }));
            setListShipName(formattedDataShip);
            setDefaultShipName({
                label: response.data.shipName, value: response.data.vesselId
            });
        }
    }

    const getDataDetailSetting = async () => {
        const response = await getSettingsById('react-client-inspection') as any;
        if (response.status === HttpStatusCode.Ok) {
            setPPNPercentage(response.data.ppn);
            setIsPPNUpdated(true);
        }
        setPPNPercentage(PPN_PERCENTAGE);
        setIsPPNUpdated(true);
    }

    const getListInspectionFee = async (value: string) => {
        const response = await getInspectorFees(value) as any;
        if (response.status === HttpStatusCode.Ok) {
            setListRawInspectionFee(response.data);
            const formattedData = response.data.map((item: any) => ({
                label: item.name,
                value: item.id,
            }));

            setListInspectionFee(formattedData);
        }
    }

    const getExchange = async () => {
        const params = {
            mts: 'USD',
            date: format(new Date(), FORMAT_ADD_DATE)
        }
        const response = await getExchangeRate(params) as any;
        if (response.status === HttpStatusCode.Ok) {
            setKurs(response.data.value);
            setKursDate(new Date(response.data.date));
        }
    }

    useEffect(() => {
        if (dataDetail && listInspectionFee) {
            const selectedData = listRawInspectionFee.find((x: any) => x.id === dataDetail?.feeId);
            setSelectedFee(selectedData);
        }
    }, [listInspectionFee])

    useEffect(() => {
        if (id && isPPNUpdated) {
            getDataDetail();
            setIsPPNUpdated(false);
        }
    }, [id, isPPNUpdated]);

    const getListCompany = async () => {
        const { formattedData, rawData } = await getListCompanyShipName();
        setListCompanyName(formattedData);
        setListRawCompanyName(rawData);
    }

    useEffect(() => {
        if (!id) {
            getListCompany();
        }
        getDataDetailSetting();
        getListCurrency('currency');
        getExchange();
    }, [])

    useEffect(() => {
        const awaitingCost = awaitingDaysFee * awaitingDays;

        const total =
            (inspectionFee ? Number(inspectionFee) : 0) +
            (awaitingCost ? Number(awaitingCost) : 0) +
            totalArray.reduce((prev, curr) => prev + curr, 0);
        const addPPn = prefix === 'IDR' ? (isPPN ? ((PPNPercentage / 100) * total) : 0) + total : total;
        setSubTotal(total);
        setPPN(isPPN ? (PPNPercentage / 100) * total : 0);
        setTotal(addPPn);
    }, [
        inspectionFee,
        awaitingDays,
        awaitingDaysFee,
        isPPN,
        totalArray,
        kurs
    ]);

    // useEffect(() => {
    //     const totalConversion = currentConversionKurs * total;
    //     setCurrentConversionAmount(totalConversion);
    // }, [currentConversionKurs, total]);

    if (id && defaultCompanyName === null && defaultShipName === null) {
        return (
            <Loader />
        );
    } else {
        return (
            <>
                <ModalConfirmation isOpen={isOpen} onClose={onClose} title={title} handleCancel={handleConfirmToCancel} handleConfirm={handleConfirm} confirmationText={confirmationText} confirmButtonText={confirmationTitleButton} />
                <div className="form-container">
                    <Formik
                        initialValues={{
                            poNumber: dataDetail?.poNumber ?? '',
                            type: dataDetail?.type ?? '',
                            sireType: dataDetail?.sireType ?? 'inspection',
                            invoiceID: dataDetail?.invoiceID ?? '',
                            companyName: defaultCompanyName?.value,
                            address: dataDetail?.address || listCompanyName.find((c: any) => c.value === dataDetail?.shipOwnerId)?.address || '',
                            shipName: defaultShipName?.value,
                            invoiceCompany: dataDetail?.invoiceCompanyId,
                            jobDescription: dataDetail?.jobDescription ?? '',
                            inspectionDate: dataDetail?.inspectionDate ?? '',
                            invoiceDate: dataDetail?.invoiceDate ?? '',
                            country: dataDetail?.country ?? '',
                            port: dataDetail?.port ?? '',
                            fee: dataDetail?.feeId ?? '',
                            isIndonesia: Boolean(dataDetail?.isIndonesia),
                            inspectionFee: dataDetail?.inspectionFee === 0 ? null : dataDetail?.inspectionFee,
                            kurs: dataDetail?.kurs === 0 ? null : dataDetail?.kurs,
                            awaitingDays: dataDetail?.awaitingDays === 0 ? null : dataDetail?.awaitingDays,
                            awaitingDaysFee: dataDetail?.awaitingDaysFee === 0 ? null : dataDetail?.awaitingDaysFee,
                            other1: dataDetail?.other1 || '',
                            otherFee1: dataDetail?.otherFee1 === 0 ? '' : dataDetail?.otherFee1 ?? undefined,
                            otherCostFile1: '',
                            other2: dataDetail?.other2 || '',
                            otherFee2: dataDetail?.otherFee2 === 0 ? '' : dataDetail?.otherFee2 ?? undefined,
                            otherCostFile2: '',
                            other3: dataDetail?.other3 || '',
                            otherFee3: dataDetail?.otherFee3 === 0 ? '' : dataDetail?.otherFee3 ?? undefined,
                            otherCostFile3: '',
                            other4: dataDetail?.other4 || '',
                            otherFee4: dataDetail?.otherFee4 === 0 ? '' : dataDetail?.otherFee4 ?? undefined,
                            otherCostFile4: '',
                            other5: dataDetail?.other5 || '',
                            otherFee5: dataDetail?.otherFee5 === 0 ? '' : dataDetail?.otherFee5 ?? undefined,
                            otherCostFile5: '',
                            other6: dataDetail?.other6 || '',
                            otherFee6: dataDetail?.otherFee6 === 0 ? '' : dataDetail?.otherFee6 ?? undefined,
                            otherCostFile6: '',
                            other7: dataDetail?.other7 || '',
                            otherFee7: dataDetail?.otherFee7 === 0 ? '' : dataDetail?.otherFee7 ?? undefined,
                            otherCostFile7: '',
                            other8: dataDetail?.other8 || '',
                            otherFee8: dataDetail?.otherFee8 === 0 ? '' : dataDetail?.otherFee8 ?? undefined,
                            otherCostFile8: '',
                            other9: dataDetail?.other9 || '',
                            otherFee9: dataDetail?.otherFee9 === 0 ? '' : dataDetail?.otherFee9 ?? undefined,
                            otherCostFile9: '',
                            other10: dataDetail?.other10 || '',
                            otherFee10: dataDetail?.otherFee10 === 0 ? '' : dataDetail?.otherFee10 ?? undefined,
                            otherCostFile10: '',
                            faktur: null,
                            isKursConversion: dataDetail?.isKursConversion || false,
                            targetExchangeRate: dataDetail?.mataUang || '',
                            conversionKurs: dataDetail?.kursConversion || '',
                            conversionNotes: dataDetail?.convertionNotes || '',
                            conversionUploadFile: dataDetail?.convertionUploadId || null,
                            conversionAmount: dataDetail?.conversionAmount || '',
                            SKTDFile: dataDetail?.sktdId || '',
                        }}
                        validationSchema={() => invoiceShipOwnerSchema(isDraft, role, savedOthersFileIds, statusKursConversion, isPPN)}
                        onSubmit={(values) => {
                            handleSubmit(values);
                        }}
                        enableReinitialize={true}
                    >
                        {(props) => (
                            <Form>
                                <div style={{ marginBottom: 15 }}>
                                    <Field name='poNumber'>
                                        {({ field, form }: FieldProps) => (
                                            <FormControl isInvalid={!!(form.errors.poNumber && form.touched.poNumber)}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">
                                                        PO Number
                                                    </FormLabel>
                                                    <div className="form-input-container">
                                                        <Input
                                                            {...field}
                                                            placeholder='PO Number'
                                                            className="form-input"
                                                            isDisabled={isSubmitting}
                                                        />
                                                        <FormErrorMessage>{form.errors.poNumber as string}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </div>
                                <Field name='type'>
                                    {({ form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.type && form.touched.type)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Type<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <SelectSireVettingType
                                                        name='type'
                                                        placeholder="Choose Type"
                                                        handleChange={({ value }: { value: string }) => handleChangeType(props, value)}
                                                        value={form.values.type}
                                                        haserror={Boolean(form.errors.type && form.touched.type)}
                                                        defaultValue={props.values.type}
                                                    />
                                                    <FormErrorMessage>{String(form.errors.type)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='sireType'>
                                    {({ form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.sireType && form.touched.sireType)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">SIRE Type<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <SelectTypeShipOperator
                                                        name='sireType'
                                                        placeholder="Choose Type"
                                                        handleChange={({ value }: { value: string }) => form.setFieldValue('sireType', value)}
                                                        value={form.values.sireType}
                                                        haserror={Boolean(form.errors.sireType && form.touched.sireType)}
                                                        defaultValue={props.values.sireType}
                                                    />
                                                    <FormErrorMessage>{String(form.errors.sireType)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                {role === 'adminfinance' && <Field name='invoiceID'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.invoiceID && form.touched.invoiceID)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Invoice ID<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <Input {...field} placeholder='Invoice ID' className="form-input" isDisabled={isSubmitting} />
                                                    <FormErrorMessage>{String(form.errors.invoiceID)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>}
                                <Field name='companyName'>
                                    {({ form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.companyName && form.touched.companyName)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Company Name<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <Select
                                                        name='companyName'
                                                        value={props.values.companyName ? listCompanyName.find((option: any) => option.value === props.values.companyName) : null}
                                                        onChange={(option: any) => {
                                                            handleSelectCompany(props, option.value);
                                                            form.setFieldValue('address', option.address || '');
                                                        }}
                                                        options={listCompanyName}
                                                        placeholder='Choose Company'
                                                        isDisabled={Boolean(isSubmitting || dataDetail?.sequenceID)}
                                                    />
                                                    <FormErrorMessage>{String(form.errors.companyName)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='address'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.address && form.touched.address)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">
                                                    Company Address
                                                </FormLabel>
                                                <div className="form-input-container">
                                                    <Input
                                                        {...field}
                                                        placeholder="Type address here..."
                                                        className="form-input"
                                                        backgroundColor="white"
                                                        borderColor="#CBD5E0"
                                                    />
                                                    <FormErrorMessage>{String(form.errors.address)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='shipName'>
                                    {({ form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.shipName && form.touched.shipName)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Vessel Name<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <Select
                                                        name='shipName'
                                                        value={props.values.shipName ? listShipName.find((option: any) => option.value === props.values.shipName) : null}
                                                        onChange={({ value }: { value: string }) => handleSelectShipName(props, value)}
                                                        options={listShipName}
                                                        //defaultValue={props.values.shipName ? listShipName.find((option: any) => option.value === defaultShipName.value) : ''}
                                                        placeholder='Choose Ship'
                                                        isDisabled={Boolean(isSubmitting || dataDetail?.sequenceID)}
                                                    />
                                                    <FormErrorMessage>{String(form.errors.shipName)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='invoiceCompany'>
                                    {({ form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.invoiceCompany && form.touched.invoiceCompany)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Invoice Company</FormLabel>
                                                <div className="form-input-container">
                                                    <SelectInvoices name='invoiceCompany' handleChange={(e: any) => handleChangeInvoiceCompany(props, e)} value={props.values.invoiceCompany} defaultValue={props.values.invoiceCompany} options={listInvoiceCompany} hasError={form.errors.invoiceCompany && form.touched.invoiceCompany} />
                                                    <FormErrorMessage>{String(form.errors.invoiceCompany)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='jobDescription'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.jobDescription && form.touched.jobDescription)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Job Description<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <Textarea {...field} placeholder='Job Description' className="form-input" isDisabled={isSubmitting} />
                                                    <FormErrorMessage>{String(form.errors.jobDescription)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name="inspectionDate">
                                    {({ form, field }: any) => (
                                        <FormControl isInvalid={Boolean(form.errors.inspectionDate && form.touched.inspectionDate)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Inspection Date<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div style={{
                                                    width: '100%',
                                                    height: '2.5rem',
                                                    fontSize: '1rem',
                                                    paddingInlineStart: '1rem',
                                                    paddingInlineEnd: '1rem',
                                                    borderRadius: '0.375rem',
                                                    minWidth: '0px',
                                                    outline: '2px solid transparent',
                                                    outlineOffset: '2px',
                                                    position: 'relative',
                                                    appearance: 'none',
                                                    transitionProperty: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
                                                    paddingTop: '0.35rem',
                                                    marginBottom: (form.errors.inspectionDate && form.touched.inspectionDate) ? '1.25rem' : 0,
                                                    border: form.errors.inspectionDate && form.touched.inspectionDate ? '2px solid red' : '1px solid #e5e7e9'
                                                }}>
                                                    <DatePicker
                                                        id="inspectionDate"
                                                        selected={field.value as Date | null}
                                                        onChange={(date: Date | null) => props.setFieldValue('inspectionDate', date)}
                                                        dateFormat="dd-MM-YYYY"
                                                        placeholderText="Inspection Date"
                                                        readOnly={isSubmitting}
                                                    />
                                                    <FormErrorMessage>{String(form.errors.inspectionDate)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='invoiceDate'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.invoiceDate && form.touched.invoiceDate)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Invoice Date<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div style={{
                                                    width: '100%',
                                                    height: '2.5rem',
                                                    fontSize: '1rem',
                                                    paddingInlineStart: '1rem',
                                                    paddingInlineEnd: '1rem',
                                                    borderRadius: '0.375rem',
                                                    minWidth: '0px',
                                                    outline: '2px solid transparent',
                                                    outlineOffset: '2px',
                                                    position: 'relative',
                                                    appearance: 'none',
                                                    transitionProperty: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
                                                    paddingTop: '0.35rem',
                                                    marginBottom: (form.errors.invoiceDate && form.touched.invoiceDate) ? '1.25rem' : 0,
                                                    border: form.errors.invoiceDate && form.touched.invoiceDate ? '2px solid red' : '1px solid #e5e7e9'
                                                }}>
                                                    <DatePicker
                                                        id="invoiceDate"
                                                        selected={field.value as Date | null}
                                                        onChange={(date: Date | null) => props.setFieldValue('invoiceDate', date)}
                                                        dateFormat="dd-MM-YYYY"
                                                        placeholderText="Invoice Date"
                                                        readOnly={isSubmitting}
                                                    />
                                                    <FormErrorMessage>{String(form.errors.invoiceDate)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='country'>
                                    {({ form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.country && form.touched.country)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Country<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <SelectCountry name='country' handleChange={({ value }: { value: string }) => props.setFieldValue('country', value)} value={props.values.country} defaultValue={props.values.country} isDisabled={isSubmitting} />
                                                    <FormErrorMessage>{String(form.errors.country)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='port'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.port && form.touched.port)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Port<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <Input {...field} placeholder='Port' className="form-input" isDisabled={isSubmitting} />
                                                    <FormErrorMessage>{String(form.errors.port)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='fee'>
                                    {({ form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.fee && form.touched.fee)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Fee<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <SelectInspectionFee
                                                        name='fee'
                                                        placeholder="Choose Type"
                                                        options={listInspectionFee}
                                                        handleChange={({ value }: { value: string }) => handleChangeFee(value, props)}
                                                        value={form.values.fee}
                                                        defaultValue={form.values.fee}
                                                        haserror={Boolean(form.errors.fee && form.touched.fee)}
                                                    />
                                                    <FormErrorMessage>{String(form.errors.fee)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='isIndonesia'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.isIndonesia && form.touched.isIndonesia)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel htmlFor='status-switch' className="form-label">
                                                    Indonesia
                                                </FormLabel>
                                                <div className="form-input-container" style={{ justifyContent: 'center' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center' }}>
                                                        <Switch
                                                            {...field}
                                                            isChecked={props.values.isIndonesia}
                                                            onChange={() => handleStatus(props)}
                                                            id='isIndonesia-switch'
                                                            style={{ backgroundColor: 'white', marginRight: '30px' }}
                                                            disabled={isSubmitting}
                                                        />
                                                        {props.values.isIndonesia && <>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ marginRight: '10px', verticalAlign: 'middle' }}>PPN</span>
                                                                <Switch
                                                                    isChecked={isPPN}
                                                                    onChange={() => setIsPPN(!isPPN)}
                                                                    id='isPPN-switch'
                                                                    style={{ backgroundColor: 'white', marginRight: '30px' }}
                                                                    disabled={isSubmitting}
                                                                />
                                                            </div>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ marginRight: '10px', verticalAlign: 'middle' }}>Signature</span>
                                                                <Switch
                                                                    isChecked={isSignature}
                                                                    onChange={() => setIsSignature(!isSignature)}
                                                                    id='isSignature-switch'
                                                                    style={{ backgroundColor: 'white', marginRight: '10px' }}
                                                                    disabled={isSubmitting}
                                                                />
                                                            </div>
                                                        </>}
                                                    </div>
                                                </div>
                                            </div>
                                            <FormErrorMessage>{String(form.errors.isIndonesia)}</FormErrorMessage>
                                        </FormControl>
                                    )}
                                </Field>
                                {(props.values.isIndonesia && props.values.type === 'sire') && <Field name='kurs'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.kurs && form.touched.kurs)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <div className="form-label" style={{ marginRight: 10 }}>
                                                    <FormLabel>Kurs<span style={{ color: 'red' }}>*</span></FormLabel>
                                                    <CurrencyExchangeDate date={kursDate} />
                                                </div>
                                                <div className="form-input-container">
                                                    <CurrencyInput
                                                        {...field}
                                                        placeholder='Kurs'
                                                        prefix={`${prefix} `}
                                                        value={kurs}
                                                        error={Boolean(form.errors.kurs && form.touched.kurs)}
                                                        onValueChange={({ floatValue = 0 }) => handleChangeKurs(floatValue, props)}
                                                        disabled={isSubmitting}
                                                        decimalScale={2}
                                                        width="100%"
                                                    />
                                                </div>
                                                <FormErrorMessage>{String(form.errors.kurs)}</FormErrorMessage>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>}
                                {props.values.isIndonesia && !isPPN &&
                                    <Field name='SKTDFile'>
                                        {({ form }: FieldProps) => (
                                            <FormControl isInvalid={Boolean(form.errors.SKTDFile && form.submitCount)} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">SKTD<span style={{ color: 'red' }}>*</span></FormLabel>
                                                    <div className="form-input-container">
                                                        <EditFile fileId={dataDetail?.sktdId ?? undefined} handleDrop={(e) => props.setFieldValue('SKTDFile', e[0])} isInvalid={Boolean(form.errors.SKTDFile && form.submitCount)} isDisabled={props.isSubmitting} type="faktur" title="SKTD" />
                                                        <FormErrorMessage>{String(form.errors.SKTDFile)}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                }
                                <Field name='inspectionFee'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.inspectionFee && form.touched.inspectionFee)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Inspection Fee<span style={{ color: 'red' }}>*</span></FormLabel>
                                                <div className="form-input-container">
                                                    <CurrencyInput
                                                        {...field}
                                                        placeholder='Inspection Fee'
                                                        prefix={`${prefix} `}
                                                        value={props.values.inspectionFee}
                                                        error={Boolean(form.errors.inspectionFee && form.touched.inspectionFee)}
                                                        onValueChange={({ floatValue = 0 }) => handleChangeInspectionFee(floatValue, props.setFieldValue)}
                                                        disabled={isSubmitting}
                                                    />
                                                    <FormErrorMessage>{String(form.errors.inspectionFee)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='awaitingDays'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.awaitingDays && form.touched.awaitingDays)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Awaiting Days</FormLabel>
                                                <div className="form-input-container">
                                                    <div>
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input'
                                                            prefix=''
                                                            value={props.values.awaitingDays}
                                                            onValueChange={({ floatValue = 0 }) => handleChangeAwaitingDays(floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                            width='10em'

                                                        />
                                                        <span style={{ marginLeft: '5px' }}>Days</span>
                                                    </div>
                                                    <FormErrorMessage>{String(form.errors.awaitingDays)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                <Field name='awaitingDaysFee'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.awaitingDaysFee && form.touched.awaitingDaysFee)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label"></FormLabel>
                                                <div className="form-input-container">
                                                    <div>
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={`${prefix} `}
                                                            value={props.values.awaitingDaysFee}
                                                            onValueChange={({ floatValue = 0 }) => handleChangeAwaitingDaysFee(floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                            width='10em'
                                                        />
                                                        <span style={{ marginLeft: '5px' }}>/ Day</span>
                                                    </div>
                                                    <FormErrorMessage>{String(form.errors.awaitingDaysFee)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                {array1to10.map((num /* 1-10 */, index /* 0-9 */) => visibleOthers.includes(num) && <>
                                    <Field name={otherArray[index]}>
                                        {({ field, form }: FieldProps) => (
                                            <FormControl isInvalid={Boolean(form.errors[otherArray[index]] && form.touched[otherArray[index]])} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Others</FormLabel>
                                                    <div className="form-input-container">
                                                        <Textarea {...field} placeholder='Description' className="form-input" isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{String(form.errors[otherArray[index]])}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name={otherFeeArray[index]}>
                                        {({ field, form }: FieldProps) => (
                                            <FormControl isInvalid={Boolean(form.errors[otherFeeArray[index]] && form.touched[otherFeeArray[index]])} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <CurrencyInput
                                                            {...field}
                                                            placeholder='Input Cost'
                                                            prefix={`${prefix} `}
                                                            value={props.values[otherFeeArray[index]]}
                                                            error={Boolean(form.errors[otherFeeArray[index]] && form.touched[otherFeeArray[index]])}
                                                            onValueChange={({ floatValue = 0 }) => handleChangeOtherCost(num, floatValue, props.setFieldValue)}
                                                            disabled={isSubmitting}
                                                            width="100%"
                                                        />
                                                        <FormErrorMessage>{String(form.errors[otherFeeArray[index]])}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name={`otherCostFile${num}`}>
                                        {({ form }: FieldProps) => (
                                            <FormControl isInvalid={Boolean(form.errors[`otherCostFile${num}`] && form.submitCount)} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label"></FormLabel>
                                                    <div className="form-input-container">
                                                        <EditFile
                                                            fileId={dataDetail?.[otherEvidenceFileIdArray[index]] ?? undefined}
                                                            handleDrop={(e) => props.setFieldValue(`otherCostFile${num}`, e[0])} //handleDrop(e, 'otherCostFile1', props.setFieldValue)}
                                                            isInvalid={Boolean(form.errors[`otherCostFile${num}`] && form.submitCount)}
                                                            type="supporting-files"
                                                            isDisabled={props.isSubmitting}
                                                            title="Other File"
                                                        />
                                                        <FormErrorMessage>{String(form.errors[`otherCostFile${num}`])}</FormErrorMessage>
                                                        {!visibleOthers.includes(num + 1) && <div>
                                                            {(num < 10) && <AddOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleAddOthers(num)} />}
                                                            {(num > 1) && <RemoveOthersIcon style={{ marginTop: '7px', marginLeft: '7px', cursor: 'pointer', display: 'inline' }} onClick={() => handleRemoveOthers(num, props.setFieldValue)} />}
                                                        </div>}
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                </>)}

                                <Field name='subTotal'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.subTotal && form.touched.subTotal)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Sub Total</FormLabel>
                                                <div className="form-input-container">
                                                    <CurrencyInput
                                                        {...field}
                                                        placeholder='Sub Total'
                                                        prefix={`${prefix} `}
                                                        value={subTotal}
                                                        defaultValue={0}
                                                        width="100%"
                                                        disabled
                                                    />
                                                    <FormErrorMessage>{String(form.errors.subTotal)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                {isPPN && <Field name='ppn'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.ppn && form.touched.ppn)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">PPN</FormLabel>
                                                <div className="form-input-container">
                                                    <CurrencyInput
                                                        {...field}
                                                        placeholder='11%'
                                                        prefix={`${prefix} `}
                                                        value={PPN}
                                                        defaultValue={0}
                                                        width="100%"
                                                        disabled
                                                    />
                                                    <FormErrorMessage>{String(form.errors.ppn)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>}
                                <Field name='totalAmount'>
                                    {({ field, form }: FieldProps) => (
                                        <FormControl isInvalid={Boolean(form.errors.totalAmount && form.touched.totalAmount)} style={{ marginBottom: 15 }}>
                                            <div className="form-field-container">
                                                <FormLabel className="form-label">Total Amount</FormLabel>
                                                <div className="form-input-container">
                                                    <CurrencyInput
                                                        {...field}
                                                        placeholder='Total Amount'
                                                        prefix={`${prefix} `}
                                                        value={total}
                                                        defaultValue={0}
                                                        width="100%"
                                                        disabled
                                                    />
                                                    <FormErrorMessage>{String(form.errors.totalAmount)}</FormErrorMessage>
                                                </div>
                                            </div>
                                        </FormControl>
                                    )}
                                </Field>
                                {role === 'adminfinance' && // we will need this field when merging edit & review invoice
                                    <Field name='faktur'>
                                        {({ form }: FieldProps) => (
                                            <FormControl isInvalid={Boolean(form.errors.faktur && form.submitCount)} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Faktur</FormLabel>
                                                    <div className="form-input-container">
                                                        <EditFile
                                                            fileId={dataDetail?.fakturId ?? undefined}
                                                            type=""
                                                            title="Faktur File"
                                                            handleDrop={() => { }}
                                                        />
                                                        <FormErrorMessage>{String(form.errors.faktur)}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                }

                                {!props.values.isIndonesia &&
                                    <>
                                        <Divider mb={2} />
                                        <Field name='isKursConversion'>
                                            {({ field, form }: FieldProps) => (
                                                <FormControl isInvalid={Boolean(form.errors.isKursConversion && form.touched.isKursConversion)} style={{ marginBottom: 15 }}>
                                                    <div className="form-field-container">
                                                        <FormLabel htmlFor='isKursConversion-switch' className="form-label">
                                                            Currency Conversion
                                                        </FormLabel>
                                                        <div className="form-input-container">
                                                            <Switch
                                                                {...field}
                                                                isChecked={props.values.isKursConversion}
                                                                onChange={() => handleChangeKursConversion(props)}
                                                                id='isKursConversion-switch'
                                                                style={{ marginTop: '5px', backgroundColor: 'white', marginRight: '30px' }}
                                                                disabled={isSubmitting}
                                                            />
                                                            <FormErrorMessage>{String(form.errors.isKursConversion)}</FormErrorMessage>
                                                        </div>
                                                    </div>
                                                </FormControl>
                                            )}
                                        </Field>
                                    </>
                                }

                                {props.values.isKursConversion &&
                                    <>
                                        <Field name='targetExchangeRate'>
                                            {({ form }: FieldProps) => (
                                                <FormControl isInvalid={Boolean(form.errors.targetExchangeRate && form.touched.targetExchangeRate)} style={{ marginBottom: 15 }}>
                                                    <div className="form-field-container">
                                                        <FormLabel className="form-label">Destination Currency<span style={{ color: 'red' }}>*</span></FormLabel>
                                                        <div className="form-input-container">
                                                            <SelectCurrencyByRefData name='targetExchangeRate' handleChange={({ value }: { value: string }) => handleChangeDestinationKurs(props, value)} value={props.values.targetExchangeRate} defaultValue={props.values.targetExchangeRate} options={listCurrency} hasError={form.errors.targetExchangeRate && form.touched.targetExchangeRate} isDisabled={isSubmitting} />
                                                            <FormErrorMessage>{String(form.errors.targetExchangeRate)}</FormErrorMessage>
                                                        </div>
                                                    </div>
                                                </FormControl>
                                            )}
                                        </Field>
                                        <Field name='conversionKurs'>
                                            {({ field, form }: FieldProps) => (
                                                <FormControl isInvalid={Boolean(form.errors.conversionKurs && form.touched.conversionKurs)} style={{ marginBottom: 15 }}>
                                                    <div className="form-field-container">
                                                        <FormLabel className="form-label">Conversion Value<span style={{ color: 'red' }}>*</span></FormLabel>
                                                        <div className="form-input-container">
                                                            <CurrencyInput
                                                                {...field}
                                                                placeholder='Input Conversion Kurs'
                                                                prefix={prefixDestination}
                                                                value={props.values.conversionKurs}
                                                                error={Boolean(form.errors.conversionKurs && form.touched.conversionKurs)}
                                                                onValueChange={({ floatValue = 0 }) => handleChangeKonversionKurs(props, floatValue)}
                                                                disabled={isSubmitting}
                                                                decimalScale={2}
                                                                width="100%"
                                                            />
                                                            <FormErrorMessage>{String(form.errors.conversionKurs)}</FormErrorMessage>
                                                        </div>
                                                    </div>
                                                </FormControl>
                                            )}
                                        </Field>
                                        <Field name='conversionAmount'>
                                            {({ field, form }: FieldProps) => (
                                                <FormControl isInvalid={Boolean(form.errors.conversionAmount && form.touched.conversionAmount)} style={{ marginBottom: 15 }}>
                                                    <div className="form-field-container">
                                                        <FormLabel className="form-label">Converted Amount<span style={{ color: 'red' }}>*</span></FormLabel>
                                                        <div className="form-input-container">
                                                            <CurrencyInput
                                                                {...field}
                                                                placeholder='Input Conversion Amount'
                                                                prefix={prefixDestination}
                                                                value={currentConversionAmount}
                                                                defaultValue={props.values.conversionAmount}
                                                                error={Boolean(form.errors.conversionAmount && form.touched.conversionAmount)}
                                                                onValueChange={({ floatValue = 0 }) => props.setFieldValue('conversionAmount', floatValue)}
                                                                width="100%"
                                                                disabled
                                                            />
                                                            <FormErrorMessage>{String(form.errors.conversionAmount)}</FormErrorMessage>
                                                        </div>
                                                    </div>
                                                </FormControl>
                                            )}
                                        </Field>
                                        <Field name='conversionNotes'>
                                            {({ field, form }: FieldProps) => (
                                                <FormControl isInvalid={Boolean(form.errors.conversionNotes && form.touched.conversionNotes)} style={{ marginBottom: 15 }}>
                                                    <div className="form-field-container">
                                                        <FormLabel className="form-label">Conversion Notes<span style={{ color: 'red' }}>*</span></FormLabel>
                                                        <div className="form-input-container">
                                                            <Textarea {...field} placeholder='Input Conversion Notes' className="form-input" isInvalid={Boolean(form.errors.conversionNotes && form.touched.conversionNotes)} />
                                                            <FormErrorMessage>{String(form.errors.conversionNotes)}</FormErrorMessage>
                                                        </div>
                                                    </div>
                                                </FormControl>
                                            )}
                                        </Field>
                                        <Field name='conversionUploadFile'>
                                            {({ form }: FieldProps) => (
                                                <FormControl isInvalid={Boolean(form.errors.conversionUploadFile && form.touched.conversionUploadFile)} style={{ marginBottom: 15 }}>
                                                    <div className="form-field-container">
                                                        <FormLabel className="form-label">Conversion File<span style={{ color: 'red' }}>*</span></FormLabel>
                                                        <div className="form-input-container">
                                                            <EditFile
                                                                title="Conversion File"
                                                                handleDrop={(e) => props.setFieldValue('conversionUploadFile', e[0])}
                                                                isInvalid={Boolean(form.errors.conversionUploadFile && form.submitCount)}
                                                                type="supporting-files"
                                                                isDisabled={props.isSubmitting}
                                                                fileId={dataDetail?.convertionUploadId ?? undefined}
                                                            />
                                                            <FormErrorMessage>{String(form.errors.conversionUploadFile)}</FormErrorMessage>
                                                        </div>
                                                    </div>

                                                </FormControl>
                                            )}
                                        </Field>
                                    </>
                                }

                                <Divider />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: 10 }}>
                                    <Button
                                        mt={4}
                                        bgColor='white'
                                        borderColor='#D0D5DD'
                                        isLoading={isSubmitting}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        mt={4}
                                        bgColor='white'
                                        borderColor='#D0D5DD'
                                        isLoading={isSubmitting}
                                        onClick={() => setIsDraft(true)}
                                        type='submit'
                                    >
                                        Save as Draft
                                    </Button>
                                    <Button
                                        mt={4}
                                        bgColor='white'
                                        borderColor='#D0D5DD'
                                        isLoading={isSubmitting}
                                        onClick={() => previewInvoice(props.values)}
                                        type='button'
                                    >
                                        Preview Invoice
                                    </Button>
                                    <Button
                                        mt={4}
                                        bgColor={COLORS.BUTTON.BACKGROUND}
                                        color={COLORS.BUTTON.FOREGROUND}
                                        isLoading={isSubmitting}
                                        onClick={() => setIsDraft(false)}
                                        type='submit'
                                        rightIcon={<ArrowIcon />}
                                    >
                                        Send Invoice
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>

                <Modal isOpen={isPreviewOpen} onClose={onPreviewClose} size='2xl'>
                    <ModalOverlay backdropFilter="blur(4px)" />
                    <ModalContent borderRadius="xl" boxShadow="2xl">
                        <ModalHeader borderBottomWidth="1px" color="blue.600">
                            Invoice Preview Details
                        </ModalHeader>
                        <ModalCloseButton />

                        <ModalBody pb={6}>
                            {isPreviewLoading ? (
                                <Stack padding="20px">
                                    <Skeleton height="20px" />
                                    <Skeleton height="20px" />
                                    <Skeleton height="20px" />
                                </Stack>
                            ) : (
                                <VStack align="stretch" spacing={5} mt={4}>
                                    <SimpleGrid columns={2} spacing={4}>
                                        <Box p={3} bg="gray.50" borderRadius="lg">
                                            <Text fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase">PO Number</Text>
                                            <Text fontSize="md" fontWeight="semibold">{previewData?.poNumber || '-'}</Text>
                                        </Box>
                                        <Box p={3} bg="blue.50" borderRadius="lg">
                                            <Text fontSize="xs" color="blue.500" fontWeight="bold" textTransform="uppercase">Vessel Name</Text>
                                            <Text fontSize="md" fontWeight="semibold">{previewData?.shipName || '-'}</Text>
                                        </Box>
                                    </SimpleGrid>
                                    <Box>
                                        <Text fontSize="sm" color="gray.500" mb={1}>Client Information</Text>
                                        <Box p={4} border="1px" borderColor="gray.100" borderRadius="lg">
                                            <Text fontWeight="bold" fontSize="lg">{previewData?.companyName || '-'}</Text>
                                            <Text fontSize="sm" color="gray.600" mt={1}>{previewData?.address || '-'}</Text>
                                        </Box>
                                    </Box>
                                    <SimpleGrid columns={2} spacing={10}>
                                        <Box>
                                            <Text fontSize="xs" color="gray.500" fontWeight="bold">INSPECTION DATE</Text>
                                            <Text fontSize="sm">{previewData?.inspectionDate || '-'}</Text>
                                        </Box>
                                        <Box>
                                            <Text fontSize="xs" color="gray.500" fontWeight="bold">INVOICE DATE</Text>
                                            <Text fontSize="sm">{previewData?.invoiceDate || '-'}</Text>
                                        </Box>
                                    </SimpleGrid>
                                    <Divider />
                                    <Box>
                                        <Text fontSize="sm" fontWeight="bold" mb={3} color="gray.700">Fee Breakdown</Text>
                                        <VStack align="stretch" spacing={2}>
                                            <Flex justify="space-between">
                                                <Text fontSize="sm">Inspection Fee</Text>
                                                <Text fontSize="sm" fontWeight="semibold">{previewData?.currencyPrefix} {previewData?.inspectionFee?.toLocaleString()}</Text>
                                            </Flex>
                                            <Flex justify="space-between">
                                                <Box>
                                                    <Text fontSize="sm">Awaiting Days</Text>
                                                    <Text fontSize="xs" color="gray.500">
                                                        {previewData?.awaitingDays} days x {previewData?.currencyPrefix} {previewData?.awaitingDaysFee?.toLocaleString()}
                                                    </Text>
                                                </Box>
                                                <Text fontSize="sm" fontWeight="semibold">{previewData?.currencyPrefix} {previewData?.awaitingCost?.toLocaleString()}</Text>
                                            </Flex>
                                            {previewData?.others?.map((o: any, idx: number) => (
                                                <Flex justify="space-between" key={idx}>
                                                    <Text fontSize="sm">{o.label}</Text>
                                                    <Text fontSize="sm" fontWeight="semibold">{previewData?.currencyPrefix} {o.amount?.toLocaleString()}</Text>
                                                </Flex>
                                            ))}
                                        </VStack>
                                    </Box>
                                    <Divider />
                                    <VStack align="stretch" spacing={1} pt={2}>
                                        <Flex justify="space-between">
                                            <Text color="gray.600">Sub Total</Text>
                                            <Text fontWeight="semibold">{previewData?.currencyPrefix} {previewData?.subTotal?.toLocaleString()}</Text>
                                        </Flex>
                                        {prefix === 'IDR' && (
                                            <Flex justify="space-between">
                                                <Text color="gray.600">PPN (11%)</Text>
                                                <Text fontWeight="semibold">{previewData?.currencyPrefix} {previewData?.ppn?.toLocaleString()}</Text>
                                            </Flex>
                                        )}
                                        <Flex justify="space-between" p={3} bg="blue.600" color="white" borderRadius="md" mt={2}>
                                            <Text fontSize="lg" fontWeight="bold">Total Amount</Text>
                                            <Text fontSize="lg" fontWeight="bold">
                                                {previewData?.currencyPrefix} {previewData?.total?.toLocaleString()}
                                            </Text>
                                        </Flex>
                                    </VStack>
                                </VStack>
                            )}
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </>
        )
    }
}

export default EditInvoicesShipOwner;
